(() => {
  const key = 'blvr-wishlist-v1';
  const buttonSelector = '[data-wishlist-button]';
  let items = read();

  function read() {
    try {
      const value = JSON.parse(localStorage.getItem(key));
      return Array.isArray(value)
        ? value.filter(item => item && /^\d+$/.test(item.id) && typeof item.title === 'string' && /^\/(?![\/\\])/.test(item.url))
        : [];
    } catch {
      return [];
    }
  }

  function updateButtons() {
    document.querySelectorAll(buttonSelector).forEach(button => {
      button.setAttribute('aria-pressed', String(items.some(item => item.id === button.dataset.id)));
      button.hidden = false;
    });
  }

  function renderPage() {
    const grid = document.querySelector('[data-wishlist-grid]');
    if (!grid) return;

    document.querySelector('[data-wishlist-status]').textContent = items.length
      ? `${items.length} saved ${items.length === 1 ? 'product' : 'products'}`
      : 'Your wishlist is empty. Tap a heart to save a product.';

    grid.replaceChildren(...items.map(item => {
      const row = document.createElement('li');
      const link = document.createElement('a');
      link.href = item.url;
      if (/^(https:\/\/|\/\/)/.test(item.image)) {
        const image = document.createElement('img');
        image.src = item.image;
        image.alt = '';
        image.loading = 'lazy';
        link.append(image);
      }
      link.append(item.title);

      const remove = document.createElement('button');
      remove.type = 'button';
      remove.dataset.wishlistRemove = item.id;
      remove.setAttribute('aria-label', `Remove ${item.title} from wishlist`);
      remove.textContent = 'Remove';
      row.append(link, remove);
      return row;
    }));
  }

  document.addEventListener('click', event => {
    const control = event.target.closest(`${buttonSelector}, [data-wishlist-remove]`);
    if (!control) return;

    const { id, title, url, image, wishlistRemove } = control.dataset;
    items = read();
    const next = wishlistRemove || items.some(item => item.id === id)
      ? items.filter(item => item.id !== (wishlistRemove || id))
      : [...items, { id, title, url, image }];

    try {
      localStorage.setItem(key, JSON.stringify(next));
    } catch {
      window.alert('Your browser could not save this wishlist change.');
      return;
    }

    const nextFocus = wishlistRemove ? [...document.querySelectorAll('[data-wishlist-remove]')].indexOf(control) : -1;
    items = next;
    updateButtons();
    renderPage();
    if (nextFocus >= 0) {
      const buttons = document.querySelectorAll('[data-wishlist-remove]');
      (buttons[Math.min(nextFocus, buttons.length - 1)] || document.querySelector('[data-wishlist-page] a'))?.focus();
    }
  });

  window.addEventListener('storage', event => {
    if (event.key !== key && event.key !== null) return;
    items = read();
    updateButtons();
    renderPage();
  });

  new MutationObserver(records => {
    if (records.some(record => [...record.addedNodes].some(node =>
      node.nodeType === 1 && (node.matches(buttonSelector) || node.querySelector(buttonSelector))
    ))) updateButtons();
  }).observe(document.body, { childList: true, subtree: true });

  updateButtons();
  renderPage();
})();
